module.exports = __webpack_public_path__ + "img/module_raspisanie.84531267.jpg";